import { EN_SITE_API_BASE } from '../api/settings';

const GET_PERIPHERAL_LICENSE_OF_LICENSEID_PATH = `/my-account/create-distribution-key/api/`;
const ADD_DOMAIN_TO_DISTRIBUTION_LICENSE_PATH = `/my-account/create-distribution-key/api/add-domain`;
const GENERATE_DISTRIBUTION_KEY_PATH = `/my-account/create-distribution-key/api/generate-distribution-key`;

/**
 * S1 function Add Domains to Distribution License POST - api/distributionlicense/adddomains
 * Call to Express API to call S1 API.  Pass encrypted LicenseID to this function.
 * @param {string} LicenseID
 */
export function addDomain(domain: string, LicenseID:string, UserID:string) {
  return new Promise((resolve, reject) => {
    fetch(`${ADD_DOMAIN_TO_DISTRIBUTION_LICENSE_PATH}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          Domain: domain,
          LicenseID:LicenseID,
          UserID: UserID
      }),
    })
      .then(resp => {
          if(resp.ok){
            return resp.json();
          }else{
              throw new Error("External API error AddDomain");
          }
      })
      .then(data => {
        resolve(data);
      })
      .catch(ex => {
        reject(ex);
      });
  });
}

/**
 * S1 function Get Peripheral Licenses of LicenseID [GET] - api/getperipherallicensesoflicenseid/{licenseid}
 * Call to Express API to call S1 API.  Pass encrypted LicenseID to this function.
 * @param {string} LicenseID
 */
export function GetPeripheralLicensesOfLicenseID(LicenseID: string) {
  return new Promise((resolve, reject) => {
    fetch(
      `${GET_PERIPHERAL_LICENSE_OF_LICENSEID_PATH}${LicenseID}`
    )
      .then(resp => {
          if(resp.ok){
            return resp.json();
          }else{
              throw new Error("External API error GetPeripheralLicensesOfLicenseID")
          } 
      })
      .then(data => {
        resolve(data);
      })
      .catch(ex => {
        reject(ex);
      });
  });
}

/**
 * S1 function Runtime Distributor/Designer License Generator [POST] - api/GenerateRunTimeLicense
 *  * Call to Express API to call S1 API.  Pass encrypted LicenseID and UserID to this function.
 * @param {*} data 
 */
export function generateDistributionKey(data: Object){
    return new Promise((resolve, reject) => {
        fetch(`${GENERATE_DISTRIBUTION_KEY_PATH}`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
        })
          .then(resp => {
              if(resp.ok){
                return resp.json();
              }else{
                  throw new Error("External API error generateDistributionKey");
              }
          })
          .then(data => {
            resolve(data);
          })
          .catch(ex => {
            reject(ex);
          });
      });
}